import { take, call, put, fork } from 'redux-saga/effects'
import fetchApi from '../../../../../utils/fetchApi'

function* getInvoiceListFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { filter, accountId },
      next
    } = yield take('GET_INVOICE_LIST')

    try {
      // const response = yield call(fetchApi, `Invoices?filter=${JSON.stringify(filter)}`)
      const response = yield call(fetchApi, `Accounts/${accountId}/invoices?filter=${JSON.stringify(filter)}`)
      if (response && !response.error) {
        yield put({ type: 'GET_INVOICE_LIST_SUCCESS', payload: response })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* createPaymentFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { next } = yield take('CREATE_PAYMENT')

    try {
      const response = yield call(fetchApi, `Billings/createPayment`, {}, { method: 'POST' })
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response)
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

export default function* invoiceFlow() {
  yield fork(getInvoiceListFlow)
  yield fork(createPaymentFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/invoice/saga/index.js